// import React, { useState } from 'react';
// import './DateSelector.css';

// const DateSelector = ({ sendDetails, onClose }) => {
//     const [issueDate, setIssueDate] = useState('');
//     const [valueDate, setValueDate] = useState('');
//     const [paymentDate, setPaymentDate] = useState('');

//     const handleOkClick = () => {
//         const selectedDates = {
//             issueDate,
//             valueDate,
//             paymentDate,
//         };
//         sendDetails(selectedDates);
//         onClose(); // Close the popup after sending the data
//     };

//     return (
//         <div className="date-selector-popup">
//             <div className="popup-content">
//                 <h3>בחר תאריכים</h3>
//                 <br></br>
//                 <div className="date-field">
//                     <label htmlFor="issue-date">תאריך הנפקה:</label>
//                     <input
//                         type="date"
//                         id="issue-date"
//                         value={issueDate}
//                         onChange={(e) => setIssueDate(e.target.value)}
//                     />
//                 </div>

//                 <div className="date-field">
//                     <label htmlFor="value-date">תאריך ערך:</label>
//                     <input
//                         type="date"
//                         id="value-date"
//                         value={valueDate}
//                         onChange={(e) => setValueDate(e.target.value)}
//                     />
//                 </div>

//                 <div className="date-field">
//                     <label htmlFor="payment-date">תאריך תשלום:</label>
//                     <input
//                         type="date"
//                         id="payment-date"
//                         value={paymentDate}
//                         onChange={(e) => setPaymentDate(e.target.value)}
//                     />
//                 </div>

//                 <div className="buttons">
//                     <button onClick={handleOkClick}>אישור</button>
//                     <button onClick={onClose}>תאריכים אוטומטים</button>
//                 </div>
//             </div>
//         </div>
//     );
// };

// export default DateSelector;


import React, { useState } from 'react';
import './DateSelector.css';

const DateSelector = ({ sendDetails, onClose }) => {
    const [issueDate, setIssueDate] = useState('');
    const [valueDate, setValueDate] = useState('');
    const [paymentDate, setPaymentDate] = useState('');

    const formatDate = (date) => {
        const [year, month, day] = date.split('-');
        return `${day}/${month}/${year}`;
    };

    const handleOkClick = () => {
        const selectedDates = {
            issueDate: formatDate(issueDate),
            valueDate: formatDate(valueDate),
            paymentDate: formatDate(paymentDate),
        };
        sendDetails(selectedDates);
        onClose(); 
    };

    const handleAutomatic = () => {
        sendDetails();
        onClose();
    }

    return (
        <div className="date-selector-popup">
            <div className="popup-content">
                <h3>בחר תאריכים</h3>
                <br></br>
                <div className="date-field">
                    <label htmlFor="issue-date">תאריך הנפקה:</label>
                    <input
                        type="date"
                        id="issue-date"
                        value={issueDate}
                        onChange={(e) => setIssueDate(e.target.value)}
                    />
                </div>

                <div className="date-field">
                    <label htmlFor="value-date">תאריך ערך:</label>
                    <input
                        type="date"
                        id="value-date"
                        value={valueDate}
                        onChange={(e) => setValueDate(e.target.value)}
                    />
                </div>

                <div className="date-field">
                    <label htmlFor="payment-date">תאריך תשלום:</label>
                    <input
                        type="date"
                        id="payment-date"
                        value={paymentDate}
                        onChange={(e) => setPaymentDate(e.target.value)}
                    />
                </div>

                <div className="buttons">
                    <button onClick={handleOkClick}>אישור</button>
                    <button onClick={handleAutomatic}>תאריכים אוטומטים</button>
                </div>
            </div>
        </div>
    );
};

export default DateSelector;
